module.exports = __webpack_public_path__ + "static/media/bg_pt-marcus_start.b0b19839.png";